import { AxiosInstance } from 'axios'
import nProgress from 'nprogress'
import { apiEndPoints, baseApiURL } from '../config'
import { IAddOrientationSchedule } from 'src/components/apps/orientationSchedule/OrientationDataType'
import { IClassParamaTypes } from 'src/types/dataTypes'
import _ from 'lodash'
import { ThroughPutDataParams } from 'src/context/common'

interface attendanceParms {
  courseCode: string
  studyModeCode: string
  academicYear: string
  programCode: string
  classDate: string
}

interface IPayload {
  deletedDocuments: any
  queryCode: string
  comment: string
  status: string
  documents: { fileName: string; fileType: string; documentTypeCode: string; isUpload?: boolean }[]
}

interface IPayloadKin {
  isKin: string
  fullName: string
  mobileNumber: string
  mobileCountryCode: string
  email: string
  relationship: string
}

interface IPayloadSponsor {
  isSponsor: string
  name: string
  email: string
  mobileNumber: string
  mobileCountryCode: string
  address: string
  sponsorModeCode: string
  relationshipCode: string
  country: string
  state: string
  city: string
  zipCode: number
}

export interface IStatusPayload {
  status?: string
  subStatus?: string
  comments?: string
}

export default class Operations {
  apiServer: AxiosInstance
  baseUrl = `${baseApiURL}operation/`
  constructor(apiServer: AxiosInstance) {
    this.apiServer = apiServer
  }

  async getCourseDetails(params?: any) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.coursedetails}?programCode=${params?.programCode}&&academicYear=${
      params?.academicYear
    }&studyModeCode=${params?.studyModeCode}`
    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAttendanceCourseDetails(params?: any) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.attedenceCourses}?programCode=${
      params?.programCode
    }&&academicYear=${params?.academicYear}&studyModeCode=${params?.studyModeCode}`
    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAttendanceDetails(params: any) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.attendance}?programCode=${params?.programCode}&academicYear=${
      params.academicYear
    }&studyModeCode=${params.studyModeCode}&courseCode=${params.courseCode}&classDate=${params.classDate}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getThroughputReport(params: any) {
    nProgress.start()
    const paramWithoutNullValue = !!params ? _.pickBy(params, _.identity) : {}
    const paramsAsQuery = !!paramWithoutNullValue
      ? `?${new URLSearchParams(paramWithoutNullValue as URLSearchParams).toString()}`
      : ''

    const endUrlName = `${this.baseUrl + apiEndPoints.throughputReport}${paramsAsQuery}`

    try {
      const response = await this.apiServer.get(endUrlName, params)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateScedule(payload: any) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.class}`
    try {
      const response = await this.apiServer.patch(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateAttedance(payload: any, classDate: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.attendanceUpdate}/${classDate}`
    try {
      const response = await this.apiServer.patch(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getScedules(params?: any) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.scedule}?programCode=${params?.programCode}&academicYear=${
      params?.academicYear
    }&studyModeCode=${params?.studyModeCode}&courseCode=${params.courseCode}`
    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getClasses(params?: IClassParamaTypes) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.test}/${params?.courseCode}/scheduleDuration/${params?.studyMode}/${
      params?.academicYear
    }`
    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAttendance(params?: attendanceParms) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.attendance}${params}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async addOrientationSchedule(payload: IAddOrientationSchedule) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.orientationSchedule}`
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching in adding Orientation Schedule list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async sendAgenda(code: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.orientationSchedule}/send-agenda/${code}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.log('Error fetching sending agenda ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getOrientationSchedule() {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.orientationSchedule}/all`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching Orientation Schedule list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async updateOrientationSchedule(payload: IAddOrientationSchedule, code: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.orientationSchedule}/${code}`
    try {
      const response = await this.apiServer.patch(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error updating schedule ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getQueryList(
    pageNumber: number,
    pageSize: number,
    query: string,
    filter: string | null,
    programCode: string | any,
    queryCode: string | any,
    startDateRange: any,
    endDateRange: any
  ) {
    nProgress.start()

    const params: { [key: string]: any } = {
      pageNumber,
      pageSize,
      search: query,
      programCode,
      queryType: queryCode,
      fromDate: startDateRange,
      toDate: endDateRange
    }

    if (filter && filter !== 'All') {
      params.status = filter
    }

    const filteredParams = Object.keys(params)
      .filter(key => params[key] !== null && params[key] !== '')
      .reduce((acc: Record<string, any>, key: string) => {
        acc[key] = params[key]

        return acc
      }, {})

    const queryString = new URLSearchParams(filteredParams).toString()
    const endUrlName = `${this.baseUrl + apiEndPoints.query}?${queryString}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateQuery(payload: IPayload) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.query}/update`
    try {
      const response = await this.apiServer.patch(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getRiskList(pageNumber: number | string, pageSize: number | string, query: string) {
    nProgress.start()
    const endUrlName = `${
      this.baseUrl + apiEndPoints.risk
    }?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${query}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async checkDuplicateEmail(applicationCode: string, email: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.checkDuplicateEmail}/${email}/leadCode/${applicationCode}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.error('Error Downloading Academic Transcript ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async updateKin(payload: IPayloadKin, applicationCode: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.updatestudent}/${applicationCode}/${apiEndPoints.updateKin}`
    try {
      const response = await this.apiServer.patch(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateSponsor(payload: IPayloadSponsor, applicationCode: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.updatestudent}/${applicationCode}/${apiEndPoints.updateSponsor}`
    try {
      const response = await this.apiServer.patch(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async editStudentStatus(payload: IStatusPayload, code: string | undefined) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.admittedStudent}`

    try {
      const response = await this.apiServer.patch(`${endUrlName}/${code}`, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching Student Status details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getThroughPutReportList(params?: ThroughPutDataParams) {
    nProgress.start()
    const paramWithoutNullValue = !!params ? _.pickBy(params, _.identity) : {}
    const paramsAsQuery = !!paramWithoutNullValue
      ? `?${new URLSearchParams(paramWithoutNullValue as URLSearchParams).toString()}`
      : ''

    const endUrlName = `${this.baseUrl + apiEndPoints.throughPut}${paramsAsQuery}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response.data
    } catch (err: any) {
      console.log('Error fetching throughPut list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
}
